import * as React from 'react';
import { Creatable as Select } from 'react-select';
import { connect } from 'react-redux';

import NotifyHOC from '../../../HOC/Notifications';
import { IApplicationState } from '../../../reducers';
import { getAllMedias } from '../../../services/media.service';
import MediaLibraryItem from './MediaLibraryItem';
import MediaLibraryAdd from './MediaLibraryAddModal';
import Loader from '../../common/Loader/Loader';
import IndicatorsContainer from '../../common/reactSelect/IndicatorsContainer';

export type MediaSelectType = 'video' | 'image' | 'all';
export const MediaSelectType = { video: 'video', image: 'image', all: 'all' };

export interface IMediaLibraryProps {
    medias?: any[];
    tags?: any[];
    type: MediaSelectType;
    showAddMedia: boolean;
    selectedMedias: any | null; // only single selected value
    selectedMediaType: 'upload' | 'medialibrary' | string;
    setSelectedMedia: (media) => void;
    getAllMedias?: () => Promise<any>;
    notify?: (
        msg: string,
        type: string,
        options?: Record<string, unknown>,
        callback?: () => unknown
    ) => any;
}

export interface IMeidaLibraryState {
    selectedTags: any[]; // important
    displayResults: any; // important
    selectedCategory: any; // important
    isLoading: boolean;
    selectedMedia: any | null;
    openModal: boolean;
}

export interface IMedia {
    label: string;
    src: string;
    tags: string; // parsable list
    thumbnail: string;
    type: 'video' | 'image' | 'gif' | string;
    userUploaded: boolean;
    value: string;
}

const sharedOptions = [
    { label: 'All Items', value: 'allResults' },
    { label: 'Default', value: 'onlyShared' },
    { label: 'Custom', value: 'onlyUser' }
];

const categoriesOptions = [
    { label: 'All Medias', value: 'all' },
    { label: 'Images', value: 'image' },
    { label: 'Gifs', value: 'gif' },
    { label: 'Videos', value: 'video' }
];

class MediaLibraryList extends React.Component<
    IMediaLibraryProps,
    IMeidaLibraryState
> {
    static defaultProps = {
        type: 'all' as MediaSelectType,
        showAddMedia: true,
        selectedMedias: null,
        selectedMediaType: 'medialibrary',
        setSelectedMedia: (selectedMedia: any) => {}
    };

    constructor(props) {
        super(props);
        this.state = {
            selectedTags: [], // important
            displayResults: { label: 'All Items', value: 'allResults' }, // important
            selectedCategory: { label: 'All Medias', value: 'all' }, // important
            isLoading: false,
            selectedMedia: null,
            openModal: false
        };
    }

    loadMedia = () => {
        this.setState({
            isLoading: true
        });
        this.props.getAllMedias().then(
            (res) => {
                this.setState({
                    isLoading: false
                });
            },
            () => {
                const category = categoriesOptions.find(
                    (x) => x.value == this.props?.type
                );
                this.setState({
                    isLoading: false,
                    selectedCategory: category
                        ? category
                        : this.state.selectedCategory
                });
            }
        );
    };

    componentDidMount() {
        /*http refactor later @todo*/
        // make it available in redux store
        // this.props.notify('success','success',{}, console.log)
        if (this.props.showAddMedia || this.props.medias.length === 0) {
            this.loadMedia();
        }
    }

    /**
     * Set Uploaded Media from this function
     * Uploaded are directly appended via redux
     * this function is used to close media for media library upload
     * otherwise will return uploaded media
     */
    setSelectedMedia = (newMedia) => {
        this.closeModal();
    };

    handleSelect = (e: any) => {
        this.setState({
            selectedTags: e,
            selectedMedia: null
        });
    };

    filteredItems = () => {
        let medias = this.props.medias || [];
        const dispalyResults = this.state.displayResults;
        // Filter Shared Items
        if (dispalyResults.value !== 'allResults') {
            medias = [
                ...medias.filter((m, i) => {
                    if (
                        dispalyResults.value === 'onlyShared' &&
                        m.userUploaded === false
                    ) {
                        return true;
                    } else if (
                        dispalyResults.value === 'onlyUser' &&
                        m.userUploaded === true
                    ) {
                        return true;
                    }
                    return false;
                })
            ];
        }
        // Filter by media types
        if (this.state.selectedCategory.value !== 'all') {
            medias = [
                ...medias.filter((m, i) => {
                    return m.type === this.state.selectedCategory.value;
                })
            ];
        }

        // filter tags
        if (this.state.selectedTags && this.state.selectedTags.length) {
            const mappedSelectedTags = this.state.selectedTags.map((m) =>
                m.value.toLowerCase()
            );
            medias = [
                ...medias.filter((m, i) => {
                    let allow = false;
                    m.tags.forEach((currentTag) => {
                        if (
                            mappedSelectedTags.includes(
                                (currentTag.value || '').toLowerCase()
                            )
                        ) {
                            allow = true;
                        }
                    });
                    mappedSelectedTags.forEach((selectedTags) => {
                        if (
                            (m.label || '')
                                .toLowerCase()
                                .indexOf(selectedTags) > -1
                        ) {
                            allow = true;
                        }
                    });
                    return allow;
                })
            ];
        }

        // Filter video data to show image data only when type is image
        const videoTypes = ['mp4', 'webm', 'ogg', 'avi', 'wnv'];
        if (this.props.type == 'image') {
            medias = [
                ...medias.filter((m, i) => {
                    return !videoTypes.includes(m.thumbnail);
                })
            ];
        } else if (this.props.type === 'video') {
            medias = [
                ...medias.filter((m, i) => {
                    return videoTypes.includes(m.thumbnail);
                })
            ];
        }

        return medias;
    };

    handleSelection = (selectedMedia: any) => {
        // @todo: change this to object directly
        if (
            this.props.selectedMedias &&
            this.props.selectedMedias.value === selectedMedia.value
        ) {
            // unselect if double clicked
            // this.setState({ selectedMedia: null });
            this.props.setSelectedMedia(null);
            return;
        }

        // this.setState({ selectedMedia });
        this.props.setSelectedMedia(selectedMedia);
    };

    handleCategorySelect = (selectedCategory) => {
        this.setState({ selectedCategory });
    };

    openModal = () => {
        this.setState({
            openModal: true
        });
    };
    closeModal = () => {
        this.setState({
            openModal: false
        });
    };

    handleRadioSelection = (filter) => {
        this.setState({ displayResults: filter });
    };

    displayCatgories = (items) => {
        const handleSelection = this.handleSelection;
        return items.map((i) => (
            <MediaLibraryItem
                key={'media' + i.value}
                selected={this.props.selectedMedias}
                handleClick={(e) => {
                    handleSelection(i);
                }}
                data={i}
            />
        ));
    };

    render() {
        let displayItems;
        const filteredItems = this.filteredItems();
        if (this.props.medias.length === 0) {
            displayItems = (
                <p className="no-results">
                    {/* @Todo: clean this portion */}
                    No results match.
                </p>
            );
        } else if (!filteredItems.length) {
            displayItems = (
                <p className="no-results">
                    No items match with this filter. See results with this tag
                    by selecting &quot;All Items&quot;.
                </p>
            );
        } else {
            // displayItems = this.displayCatgories(this.state.filteredMatches);
            displayItems = this.displayCatgories(filteredItems);
        }
        return (
            <div className="media-library-content">
                <div className="media-library--filters">
                    <div className="filters--search-tags">
                        <Select
                            className="react-select filter"
                            classNamePrefix="react-select"
                            value={this.state.selectedTags}
                            onChange={this.handleSelect}
                            isMulti
                            isSearchable
                            placeholder="Search tags or use dropdown to filter results..."
                            options={this.props.tags || []}
                            components={{
                                IndicatorsContainer
                            }}
                            // menuIsOpen={false}
                        />
                    </div>
                    <div className="filters--shared">
                        <Select
                            className="react-select filter"
                            classNamePrefix="react-select"
                            value={this.state.displayResults}
                            onChange={this.handleRadioSelection}
                            isSearchable
                            placeholder="Search tags or use dropdown to filter results..."
                            options={sharedOptions}
                            components={{
                                IndicatorsContainer
                            }}
                        />
                    </div>
                    <div className="filters--categories">
                        <Select
                            className="react-select filter"
                            classNamePrefix="react-select"
                            value={this.state.selectedCategory}
                            onChange={(e) => this.handleCategorySelect(e)}
                            isSearchable
                            placeholder="Search tags or use dropdown to filter results..."
                            options={categoriesOptions}
                            components={{
                                IndicatorsContainer
                            }}
                        />
                    </div>
                    {(this.props.showAddMedia && (
                        <div className="filters--action-buttons">
                            <button
                                className="btn btn--md btn--green"
                                onClick={this.openModal}
                            >
                                <i className="nx nx-add"></i>Add medias
                            </button>
                        </div>
                    )) ||
                        null}
                </div>
                {this.state.isLoading ? (
                    <Loader />
                ) : (
                    <div className="media-library--media-list-container row">
                        <div className="col-md-12 media-library--media-list list-box list-box--media">
                            {displayItems}
                        </div>
                        {this.props.showAddMedia && this.state.openModal ? (
                            <MediaLibraryAdd
                                isOpen={this.state.openModal}
                                setSelectedMedia={this.setSelectedMedia}
                                notify={this.props.notify}
                                onCancel={this.closeModal}
                                onClose={this.closeModal}
                                type={this.props.type}
                                showMediaLibrary={false}
                            />
                        ) : null}
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = ({ mediaReducer }: IApplicationState) => ({
    medias: mediaReducer.medias,
    tags: mediaReducer.tags
});

const mapDispatchToProps = (dispatch) => ({
    getAllMedias: () => dispatch(getAllMedias())
});

export default NotifyHOC(
    connect(mapStateToProps, mapDispatchToProps)(MediaLibraryList)
);
